import styled from 'styled-components';
import CashbackIndicator from '@/shared/assets/cashback-indicator.svg';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { CashbackIndicatorActive } from './cashback-indicator-active';

export const Wrapper = styled.div`
  padding: 20px;
  padding-bottom: 40px;
  background-image: url('/images/background/cashback-background.jpg');
  background-repeat: no-repeat;
  margin-top: 16px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding-bottom: 64px;
  }

  ${({ $status }) =>
    $status === 'done' &&
    `
    padding-bottom:0;

    @media (max-width: 768px) {
        padding-bottom: 64px;
        }
   &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height:100%;
    background: linear-gradient(270deg, #131315 0%, rgba(31, 120, 255, 0.00) 100%);
    z-index: 1;
    }
  `}
`;

export const Tag = styled.div`
  display: flex;
  height: 24px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: #27262b;
  border-radius: 8px;
  position: relative;
  z-index: 3;
  @media (max-width: 768px) {
    position: absolute;
    right: 20px;
    top: 20px;
  }
`;

export const StyledCashbackIndicator = styled(CashbackIndicator)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  ${({ $status }) =>
    $status === 'done' &&
    `
                       bottom:-16px;

      `}
`;

// export const StyledCashbackIndicatorActive = styled(CashbackIndicatorActive)`

//   ${({ $status }) =>
//     $status === 'done' &&
//     `
//                bottom:-16px;
//       `}
// `;

export const Wagers = styled.div`
  padding: 10px 16px;
  position: absolute;
  right: 20px;
  bottom: 20px;
  border-radius: 52px;
  background: rgba(18, 22, 32, 0.4);
  backdrop-filter: blur(8px);
  z-index: 1;
  display: flex;
`;

export const FinishedWager = styled.div`
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 3;
`;

export const StyledTooltip = styled(Tooltip)`
  background-color: #27262b !important;
  border-radius: 8px !important;
  color: #ccd1e2;
  max-width: 320px;
  z-index: 10;
  position: relative;
  /* font-family: Onest;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; */
`;
